import React from 'react';
import './RecalledRecordsChart.scss';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { ANIMATION_DURATION } from '../../config/DashboardConfig';

const renderTooltip = ({ active, payload, label }) => {
  if (active && payload) {

    const { barcode, phototaking, name } = payload[0].payload;

    return (
      <div className="recalled-records-chart-tool-tips">
        <div className="recalled-records-chart-info">{`${name}`}</div>
        <div className="recalled-records-chart-info barcode">{`Barcode: ${barcode}`}</div>
        <div className="recalled-records-chart-info photo">{`Take photo: ${phototaking}`}</div>
      </div>
    );
  }
  return null;
};

const RecalledRecordsChart = ({ width, data, height, dataGrow }) => {
  if (!data) {
    return <div style={{ width, height }} />;
  }



const axisTextStyle = {
  fontFamily: 'Mulish',
  fontSize: 14,
  fontWeight: 400,
};

return (
    <LineChart
      width={width}
      height={height}
      data={data}
    >
      <defs>
        <linearGradient id="green" x1="0" y1="0" x2="0" y2="1">
          <stop offset="42%" stopColor="rgba(0, 138, 96, 1)" />
          <stop offset="97.91%" stopColor="rgba(0, 138, 96, 0)" />
        </linearGradient>
        <linearGradient id="red" x1="0" y1="0" x2="0" y2="1">
          <stop offset="42%" stopColor="rgba(206, 0, 69, 1)" />
          <stop offset="97.91%" stopColor="rgba(206, 0, 69, 0)" />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="3 3" vertical={false} />
      <XAxis dataKey="name" axisLine={{ stroke: '#3D8862',  strokeWidth: 3 }} tick={{ 
              ...axisTextStyle,
              fill: '#8C8C8C',        // text color
              dy: 10,                 // vertical offset
            }} />
      <YAxis  axisLine={{ stroke: '#FFFFFF' }}  tickLine={{ stroke: '#FFFFFF' }} tick={{ 
              ...axisTextStyle,
              fill: '#8C8C8C',        // text color
              dy: 0,                 // vertical offset
            }} />
      <Tooltip content={renderTooltip} />
      <Legend />
      <Line type="monotone" dot={{ r:4, fill: '#FFFFFF',stroke: '#2B84EE', strokeWidth: 2, strokeDasharray: "0"  }} dataKey="barcode" stroke="#2B84EE" strokeDasharray="5 5" />
      <Line type="monotone" dot={{ r:4, fill: '#FFFFFF',stroke: '#FF6B4A', strokeWidth: 2, strokeDasharray: "0"  }} dataKey="phototaking" stroke="#FF6B4A" strokeDasharray="5 5" /> 
    </LineChart>
  );
};

export default RecalledRecordsChart;
